var _style, _filter, _g, _polyline, _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-1615 1184.2 224.7 224.8",
    style: {
      enableBackground: "new -1615 1184.2 224.7 224.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-industry{filter:url(#filter-2);}\n\t.st1-industry{fill:none;}\n\t.st2-industry{fill:#00BAFF;}\n\t.st3-industry{fill:url(#SVGID_1_);}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    width: "200%",
    height: "200%",
    filterUnits: "userSpaceOnUse",
    y: "-50%",
    id: "filter-2",
    x: "-50%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0,
    dx: 0,
    result: "shadow-1-feOffset-shadow",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "shadow-1-feGaussianBlur-shadow",
    in: "shadow-1-feOffset-shadow",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0.7333333333333333  0 0 0 0 1  0 0 0 0.5 0",
    result: "shadow-1-feColorMatrix-shadow",
    in: "shadow-1-feGaussianBlur-shadow"
  }))), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0-industry"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1_1_",
    x: -1555,
    y: 1244.2,
    width: 104.7,
    height: 104.8
  }))), /*#__PURE__*/React.createElement("g", null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1-industry",
    points: "-1450.6,1348.6 -1555,1348.6 -1555,1244.2 -1450.6,1244.2  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2-industry",
    d: "M-1498.1,1305.3c0,0.2,0,0.4,0,0.6c0,7.9-6.4,14.2-14.2,14.2s-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2 c0.3,0,0.7,0,1,0l7.8-7.8c-2.7-1.1-5.7-1.7-8.8-1.7c-13.1,0-23.7,10.6-23.7,23.7c0,13.1,10.6,23.7,23.7,23.7 c13.1,0,23.7-10.6,23.7-23.7c0-3-0.6-5.9-1.6-8.5L-1498.1,1305.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2-industry",
    d: "M-1486.5,1293.8c1.7,3.7,2.7,7.8,2.7,12.1c0,15.7-12.7,28.5-28.5,28.5s-28.5-12.7-28.5-28.5 s12.7-28.5,28.5-28.5c4.5,0,8.7,1,12.4,2.8l7-7c-5.7-3.4-12.3-5.3-19.4-5.3c-21,0-38,17-38,38s17,38,38,38c21,0,38-17,38-38 c0-7-1.9-13.5-5.2-19.2L-1486.5,1293.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1465.3622,
    y1: 1335.4321,
    x2: -1512.2126,
    y2: 1288.5817,
    gradientTransform: "matrix(1 0 0 -1 0 2594.3887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#00BAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004DFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3-industry",
    points: "-1455.3,1269 -1475.4,1248.9 -1488.9,1262.3 -1488.9,1275.7 -1515.5,1302.4 -1508.9,1309.2  -1479.2,1279.5 -1479.3,1266.1 -1475.4,1262.3 -1468.7,1269 -1475.4,1275.7 -1475.4,1282.4 -1468.7,1282.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.792a9315f49f5936f6a7dbc01d2eef40.svg";
export { ForwardRef as ReactComponent };